import { Col } from '@/components/ui/col'
export function PosMockupScreenHighlands() {
  return (
    <Col className="relative flex h-full w-1/3 bg-[#f5f0e6]">
      <div className="flex h-14 flex-shrink-0 items-center justify-between border-b border-highlands-dark bg-highlands px-4 text-white">
        <div className="flex items-center gap-4">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white p-1 shadow-sm">
            <div className="flex h-full w-full items-center justify-center rounded-full border-2 border-highlands bg-white">
              <div className="h-2 w-2 rounded-full bg-highlands" />
            </div>
          </div>
          <Col className="">
            <span className="mt-1 text-lg font-bold leading-none tracking-wide">Highlands Coffee POS</span>
            <span className="mt-0.5 font-mono text-fs-md text-white/80">HC Landmark 81 | Store #810</span>
          </Col>
        </div>
        <div className="flex items-center gap-6 font-mono text-xs text-white/90">
          <span className="hidden sm:inline-block">
            Máy POS: <strong>T-01</strong>
          </span>
          <span className="hidden sm:inline-block">
            Thu ngân: <strong>Lan N.</strong>
          </span>
          <span className="pos-time rounded bg-highlands-dark px-3 py-1.5 text-sm font-bold text-white shadow-inner">
            --:--:--
          </span>
        </div>
      </div>

      <div className="relative flex flex-1 overflow-hidden">
        <Col className="flex flex-1 overflow-hidden border-r border-gray-200 bg-white">
          <div className="mock-scroll flex flex-shrink-0 gap-2 overflow-x-auto border-b border-gray-200 bg-gray-50 p-3">
            <button
              type="button"
              className="flex-shrink-0 rounded bg-highlands px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-white"
            >
              Signatures
            </button>
            <button
              type="button"
              className="flex-shrink-0 rounded border border-gray-300 bg-white px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-charcoal-600 hover:border-highlands hover:text-highlands"
            >
              Cà Phê Phin
            </button>
            <button
              type="button"
              className="flex-shrink-0 rounded border border-gray-300 bg-white px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-charcoal-600 hover:border-highlands hover:text-highlands"
            >
              Freeze
            </button>
            <button
              type="button"
              className="flex-shrink-0 rounded border border-gray-300 bg-white px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-charcoal-600 hover:border-highlands hover:text-highlands"
            >
              Trà
            </button>
            <button
              type="button"
              className="flex-shrink-0 rounded border border-gray-300 bg-white px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-charcoal-600 hover:border-highlands hover:text-highlands"
            >
              Bánh Mì
            </button>
          </div>

          <div className="mock-scroll grid grid-cols-2 content-start gap-3 overflow-y-auto bg-[#fcfbf9] p-4 lg:grid-cols-3">
            <Col className="flex h-28 cursor-pointer justify-between rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-highlands hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Trà Sen Vàng</span>
              <span className="mt-2 font-mono text-sm font-bold text-highlands">55,000 ₫</span>
            </Col>
            <Col className="flex h-28 cursor-pointer justify-between rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-highlands hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Phin Sữa Đá</span>
              <span className="mt-2 font-mono text-sm font-bold text-charcoal-600">35,000 ₫</span>
            </Col>
            <Col className="flex h-28 cursor-pointer justify-between rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-highlands hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Phindi Hạnh Nhân</span>
              <span className="mt-2 font-mono text-sm font-bold text-charcoal-600">55,000 ₫</span>
            </Col>
            <Col className="flex h-28 cursor-pointer justify-between rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-highlands hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Freeze Trà Xanh</span>
              <span className="mt-2 font-mono text-sm font-bold text-charcoal-600">65,000 ₫</span>
            </Col>
            <Col className="flex h-28 cursor-pointer justify-between border-l-4 border-l-orange-400 rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-highlands hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Bánh Mì Thịt Nướng</span>
              <span className="mt-2 font-mono text-sm font-bold text-orange-600">29,000 ₫</span>
            </Col>
            <Col className="flex h-28 cursor-pointer justify-between border-l-4 border-l-orange-400 rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-highlands hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Combo: Phin + Bánh</span>
              <span className="mt-2 font-mono text-sm font-bold text-highlands">59,000 ₫</span>
            </Col>
          </div>
        </Col>

        <Col className="z-10 flex w-80 flex-shrink-0 bg-white shadow-[-4px_0_15px_-3px_rgba(0,0,0,0.05)] lg:w-96">
          <div className="flex items-center justify-between border-b border-gray-200 bg-red-50/50 p-4">
            <Col className="">
              <span className="text-xl font-bold text-charcoal-900">Đơn #8901</span>
              <span className="mt-0.5 font-mono text-fs-md uppercase text-charcoal-500">Khách mang đi</span>
            </Col>
            <span className="rounded-md bg-green-600 px-2.5 py-1.5 text-fs-sm font-bold uppercase tracking-widest text-white shadow-sm">
              TAKE AWAY
            </span>
          </div>

          <Col className="mock-scroll flex flex-1 gap-5 overflow-y-auto p-4">
            <div className="group flex items-start justify-between">
              <div className="flex gap-3">
                <span className="flex h-7 w-7 items-center justify-center rounded border border-gray-200 bg-gray-100 text-sm font-bold text-charcoal-900">
                  1
                </span>
                <Col className="">
                  <span className="text-sm font-bold text-charcoal-900">Trà Sen Vàng</span>
                  <span className="mt-1 flex items-center gap-1 text-xs text-charcoal-500">
                    <svg className="h-3 w-3 text-highlands" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>{' '}
                    Upsize L (+10,000 ₫)
                  </span>
                  <span className="mt-0.5 flex items-center gap-1 text-xs text-charcoal-500">
                    <svg className="h-3 w-3 text-highlands" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>{' '}
                    Thêm Sen (+10,000 ₫)
                  </span>
                </Col>
              </div>
              <span className="font-mono text-sm font-semibold text-charcoal-900">75,000 ₫</span>
            </div>

            <div className="group flex items-start justify-between">
              <div className="flex gap-3">
                <span className="flex h-7 w-7 items-center justify-center rounded border border-gray-200 bg-gray-100 text-sm font-bold text-charcoal-900">
                  2
                </span>
                <Col className="">
                  <span className="text-sm font-bold text-charcoal-900">Combo Sáng</span>
                  <span className="mt-1 border-l-2 border-gray-200 pl-2 text-xs text-charcoal-500">- Phin Sữa Đá</span>
                  <span className="mt-0.5 border-l-2 border-gray-200 pl-2 text-xs text-charcoal-500">
                    - Bánh Mì Thịt Nướng
                  </span>
                </Col>
              </div>
              <span className="font-mono text-sm font-semibold text-charcoal-900">59,000 ₫</span>
            </div>

            <div className="group flex w-full items-start justify-between">
              <div className="flex flex-1 gap-3">
                <span className="flex h-7 w-7 items-center justify-center rounded border border-gray-200 bg-gray-100 text-sm font-bold text-charcoal-900">
                  3
                </span>
                <Col className="w-full">
                  <div className="flex justify-between">
                    <span className="text-sm font-bold text-charcoal-900">Phindi Hạnh Nhân</span>
                    <span className="font-mono text-sm font-semibold text-charcoal-900">55,000 ₫</span>
                  </div>
                  <div className="mt-1 flex justify-between">
                    <span className="flex items-center gap-1 text-fs-md font-medium text-highlands">
                      <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                        />
                      </svg>{' '}
                      Voucher Mua 1 Tặng 1
                    </span>
                    <span className="font-mono text-fs-md font-semibold text-highlands">-55,000 ₫</span>
                  </div>
                </Col>
              </div>
            </div>
          </Col>

          <div className="border-t border-gray-200 bg-gray-50 p-5">
            <div className="mb-2 flex justify-between text-sm text-charcoal-600">
              <span>Tạm tính</span>
              <span className="font-mono">189,000 ₫</span>
            </div>
            <div className="mb-2 flex justify-between text-sm font-medium text-highlands">
              <span>Giảm giá</span>
              <span className="font-mono">-55,000 ₫</span>
            </div>
            <div className="mb-4 flex justify-between text-sm text-charcoal-600">
              <span>VAT (8%)</span>
              <span className="font-mono">10,720 ₫</span>
            </div>
            <div className="mb-4 h-px w-full bg-gray-200" />
            <div className="mb-6 flex items-end justify-between">
              <span className="text-sm font-bold uppercase tracking-wide text-charcoal-900">Tổng cộng</span>
              <span className="font-mono text-3xl font-bold leading-none text-highlands">144,720 ₫</span>
            </div>

            <div className="flex gap-3">
              <button
                type="button"
                className="w-1/3 rounded-lg border-2 border-gray-300 bg-white py-3.5 text-xs font-bold uppercase tracking-wide text-charcoal-900 transition-colors hover:bg-gray-100"
              >
                LƯU ĐƠN
              </button>
              <button
                type="button"
                className="w-2/3 rounded-lg bg-highlands py-3.5 text-sm font-bold uppercase tracking-widest text-white shadow-lg shadow-highlands/30 transition-all hover:bg-highlands-dark"
              >
                THANH TOÁN
              </button>
            </div>
          </div>
        </Col>
      </div>
    </Col>
  )
}
